import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import { Lightbox } from "react-modal-image"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeMarketerReject extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  usermarketer_id: "",
                  marketer_deactive: "",
                  marketer_request: "",
                  marketer_reason: "",
                  marketer_city: "",
                  marketer_check_coworker: "",
                  marketer_refund: "",
                  marketer_filedinsur_favorit: "",
                  marketer_reason_select: "",
                  marketer_expect: "",
                  marketer_detail: "",

                  marketer_user_id: "",
                  user_name: "",
                  user_family: "",
                  user_mobile: "",
                  marketer_leader_mobile: "",
                  user_email: "",
                  user_national_code: "",
                  user_national_image_tumb: "",
                  user_national_image: "",
                  user_back_national_image_tumb: "",
                  user_back_national_image: "",
                  marketer_image: "",
                  marketer_image_tumb: "",
                  optionMarketerMode: [],
                  selectedMarketerMode: "",
                  marketer_coworker: "",

                  orderBy: "usermarketer_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  openImageBox: false,
                  marketeFilterMobile: "",
                  marketeFilterId: "",
                  marketeFilterName: "",
            }
      }

      handleChangeMarketerRejectReason = (event) => {
            this.setState({ marketer_reason: event.target.value })
      }

      handleChangeMarketerCheckCoworker = (event) => {
            this.setState({ marketer_check_coworker: event.target.value })
      }

      andleChangeMarketerCheckCoworker = (event) => {
            this.setState({ marketer_check_coworker: event.target.value })
      }
      handleChangeMarketerActiveRefund = (event) => {
            this.setState({ marketer_refund: event.target.value })
      }
      handleChangeMarketerActiveFieldInsurFavorit = (event) => {
            this.setState({ marketer_filedinsur_favorit: event.target.value })
      }
      handleChangeMarketerActiveReasonSelect = (event) => {
            this.setState({ marketer_reason_select: event.target.value })
      }
      handleChangeMarketerActiveExpect = (event) => {
            this.setState({ marketer_expect: event.target.value })
      }
      handleChangeMarketerActiveDetail = (event) => {
            this.setState({ marketer_detail: event.target.value })
      }

      handleChangeMarketerCity = (event) => {
            this.setState({ marketer_city: event.target.value })
      }

      handleChangeCarFilterMobile = (event) => {
            this.setState({ marketeFilterMobile: event.target.value }, () => {
                  this.filterFieldCompany()
            })
      }

      handleChangeCarFilterId = (event) => {
            this.setState({ marketeFilterId: event.target.value }, () => {
                  this.filterFieldCompany()
            })
      }
      handleChangeCarFilterName = (event) => {
            this.setState({ marketeFilterName: event.target.value }, () => {
                  this.filterFieldCompany()
            })
      }

      handleMarketerMode = (selectedMarketerMode) => {
            this.setState({ selectedMarketerMode: selectedMarketerMode, marketer_mode_color: selectedMarketerMode.logo })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      newReuest = () => {
            this.setState(
                  {
                        usermarketer_id: "",
                        marketer_deactive: "",
                        marketer_request: "",
                        marketer_reason: "",
                        marketer_city: "",
                        marketer_check_coworker: "",
                        marketer_refund: "",
                        marketer_filedinsur_favorit: "",
                        marketer_reason_select: "",
                        marketer_expect: "",
                        marketer_detail: "",

                        marketer_user_id: "",
                        user_name: "",
                        user_family: "",
                        marketer_leader_mobile: "",
                        user_mobile: "",
                        user_email: "",
                        user_national_code: "",
                        user_national_image_tumb: "",
                        user_national_image: "",
                        user_back_national_image_tumb: "",
                        user_back_national_image: "",
                        marketer_image: "",
                        marketer_image_tumb: "",
                        marketer_coworker: "",
                  },
                  () => {}
            )
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        usermarketer_id: row2.usermarketer_id,
                        marketer_deactive: row2.marketer_deactive,
                        marketer_request: row2.marketer_request,
                        marketer_reason: row2.marketer_reason,
                        marketer_city: row2.marketer_city,
                        marketer_check_coworker: row2.marketer_check_coworker,
                        marketer_refund: row2.marketer_refund,
                        marketer_filedinsur_favorit: row2.marketer_filedinsur_favorit,
                        marketer_reason_select: row2.marketer_reason_select,
                        marketer_expect: row2.marketer_expect,
                        marketer_detail: row2.marketer_detail,
                        selectedMarketerMode: { value: row2.marketer_mode_id, label: row2.marketer_mode_namefa },
                        marketer_coworker: row2.marketer_coworker,

                        marketer_user_id: row2.marketer_user_id,
                        user_name: row2.user_name,
                        user_family: row2.user_family,
                        user_mobile: row2.user_mobile,
                        marketer_leader_mobile: row2.marketer_leader_mobile,
                        user_email: row2.user_email,
                        user_national_code: row2.user_national_code,
                        user_national_image_tumb: row2.user_national_image_tumb,
                        user_national_image: row2.user_national_image,
                        user_back_national_image_tumb: row2.user_back_national_image_tumb,
                        user_back_national_image: row2.user_back_national_image,
                        marketer_image: row2.marketer_image,
                        marketer_image_tumb: row2.marketer_image_tumb,
                  },
                  () => {}
            )
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getMarketerReject()
                                    self.getoptionMarketerMode()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getMarketerReject() {
            const { rowsPerPage, page } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data, arrCount: arr.cnt }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_reject_marketer")

            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/marketeractive`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionMarketerMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var MarketerMode = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    MarketerMode.push({
                                          value: arr.data[k].marketer_mode_id,
                                          label: arr.data[k].marketer_mode_namefa,
                                          logo: arr.data[k].marketer_mode_color,
                                    })
                              }
                              self.setState({ optionMarketerMode: MarketerMode, selectedMarketerMode: MarketerMode[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_marketer_mode")

            xhttp.open("POST", `${constants.BASE_URL}/comission`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeActiveMarketerReject = () => {
            const {
                  marketer_user_id,
                  marketer_deactive,
                  marketer_reason,
                  marketer_city,
                  marketer_check_coworker,
                  marketer_refund,
                  marketer_filedinsur_favorit,
                  marketer_reason_select,
                  marketer_expect,
                  marketer_detail,
                  selectedMarketerMode,
            } = this.state
            if (marketer_user_id != "" && selectedMarketerMode != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getMarketerReject()
                                    self.newReuest()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "avtive_marketer")
                  fd.append("marketer_user_id", marketer_user_id)
                  fd.append("marketer_mode_id", selectedMarketerMode.value)
                  fd.append("marketer_city", marketer_city)
                  fd.append("marketer_reason", marketer_reason)
                  fd.append("marketer_check_coworker", marketer_check_coworker)
                  fd.append("marketer_refund", marketer_refund)
                  fd.append("marketer_filedinsur_favorit", marketer_filedinsur_favorit)
                  fd.append("marketer_reason_select", marketer_reason_select)
                  fd.append("marketer_expect", marketer_expect)
                  fd.append("marketer_detail", marketer_detail)
                  fd.append("marketer_city", marketer_city)

                  xhttp.open("POST", `${constants.BASE_URL}/marketeractive`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات مقصد  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getMarketerReject()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getMarketerReject()
            })
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      filterFieldCompany = () => {
            const {
                  marketeFilterMobile,
                  marketeFilterId,
                  marketeFilterName,
                  selectedFilterCarMode,
                  selectedFilterCarCompany,
                  selectedFilterCarGroup,
                  requestinfos,
            } = this.state

            var temparray = requestinfos,
                  temparray2 = [],
                  i,
                  namefamily
            for (i = 0; i < temparray.length; i++) {
                  namefamily = temparray[i].user_name + " " + temparray[i].user_family
                  if (
                        (marketeFilterMobile === "" || temparray[i].user_mobile.indexOf(marketeFilterMobile) !== -1) &&
                        (marketeFilterId === "" || temparray[i].marketer_user_id.indexOf(marketeFilterId) !== -1) &&
                        (marketeFilterName === "" || namefamily.indexOf(marketeFilterName) !== -1)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  marketeFilterMobile,
                  marketer_coworker,
                  marketeFilterId,
                  marketeFilterName,
                  optionMarketerMode,
                  selectedMarketerMode,
                  marketer_image_tumb,
                  marketer_user_id,
                  user_name,
                  user_family,
                  user_mobile,
                  marketer_leader_mobile,
                  user_email,
                  user_national_code,
                  user_national_image_tumb,
                  user_national_image,
                  user_back_national_image_tumb,
                  user_back_national_image,
                  marketer_image,
                  snackMode,
                  snackstr,
                  showSnack,
                  usermarketer_id,
                  marketer_deactive,
                  marketer_reason,
                  marketer_check_coworker,
                  marketer_refund,
                  marketer_filedinsur_favorit,
                  marketer_reason_select,
                  marketer_expect,
                  marketer_detail,
                  marketer_city,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={12}></Grid>

                                                            <Grid item xs={3}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی کاربر:   " + marketer_user_id}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={5}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"نام کاربر :   " + user_name + " " + user_family}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <Typography align="center" variant="h7">
                                                                        {" همراه :   " + user_mobile}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Typography align="center" variant="h7">
                                                                        {" ایمیل :   " + user_email}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Typography align="center" variant="h7">
                                                                        {" کد ملی :   " + user_national_code}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Typography align="center" variant="h7">
                                                                        {" همراه معرف :   " + marketer_leader_mobile}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"  همکار صنعت بیمه :   "} {marketer_coworker === "true" ? "بله" : "خیر"}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <Typography variant="h7">{"تصویر روی کارت ملی: "}</Typography>

                                                                  <Avatar
                                                                        variant="rounded"
                                                                        alt="Remy Sharp"
                                                                        src={user_national_image_tumb}
                                                                        onClick={() => {
                                                                              this.setImageModel(
                                                                                    user_national_image_tumb,
                                                                                    user_national_image,
                                                                                    " تصویر روی کارت ملی"
                                                                              )
                                                                        }}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <Typography variant="h7">{"تصویر پشت کارت ملی: "}</Typography>

                                                                  <Avatar
                                                                        variant="rounded"
                                                                        alt="Remy Sharp"
                                                                        src={user_back_national_image_tumb}
                                                                        onClick={() => {
                                                                              this.setImageModel(
                                                                                    user_back_national_image_tumb,
                                                                                    user_back_national_image,
                                                                                    "تصویر پشت کارت ملی: "
                                                                              )
                                                                        }}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <Typography variant="h7">{"تصویر درخواست: "}</Typography>

                                                                  <Avatar
                                                                        variant="rounded"
                                                                        alt="Remy Sharp"
                                                                        src={marketer_image_tumb}
                                                                        onClick={() => {
                                                                              this.setImageModel(
                                                                                    marketer_image_tumb,
                                                                                    marketer_image,
                                                                                    "تصویر درخواست: "
                                                                              )
                                                                        }}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع بازاریاب</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع بازاریاب"}
                                                                              value={selectedMarketerMode}
                                                                              onChange={this.handleMarketerMode}
                                                                              options={optionMarketerMode}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات بررسی "
                                                                        handleInputt={this.handleChangeMarketerRejectReason}
                                                                        value={marketer_reason}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder=" همکار صنعت بیمه "
                                                                        handleInputt={this.handleChangeMarketerCheckCoworker}
                                                                        value={marketer_check_coworker}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder=" نحوه آشنایی "
                                                                        handleInputt={this.handleChangeMarketerActiveRefund}
                                                                        value={marketer_refund}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="  شهر "
                                                                        handleInputt={this.handleChangeMarketerCity}
                                                                        value={marketer_city}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder=" رشته های مورد علاقه "
                                                                        handleInputt={this.handleChangeMarketerActiveFieldInsurFavorit}
                                                                        value={marketer_filedinsur_favorit}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder=" دلیل انتخاب رهنمایه بیمه "
                                                                        handleInputt={this.handleChangeMarketerActiveReasonSelect}
                                                                        value={marketer_reason_select}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder=" انتظارات از رهنمایه بیمه "
                                                                        handleInputt={this.handleChangeMarketerActiveExpect}
                                                                        value={marketer_expect}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder=" توضیحات "
                                                                        handleInputt={this.handleChangeMarketerActiveDetail}
                                                                        value={marketer_detail}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder=" شهر "
                                                                        handleInputt={this.handleChangeMarketerCity}
                                                                        value={marketer_city}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <div style={{ width: "100%", textAlign: "right" }}>
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.changeActiveMarketerReject()
                                                                              }}
                                                                        >
                                                                              {"تایید درخواست "}
                                                                        </Button>
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="ای دی کاربر  "
                                                                        handleInputt={this.handleChangeCarFilterId}
                                                                        value={marketeFilterId}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شماره همراه "
                                                                        handleInputt={this.handleChangeCarFilterMobile}
                                                                        value={marketeFilterMobile}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام کاربر  "
                                                                        handleInputt={this.handleChangeCarFilterName}
                                                                        value={marketeFilterName}
                                                                  />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"marketer_user_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "marketer_user_id" ? order : false}
                                                                              >
                                                                                    {"آیدی کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "marketer_user_id"}
                                                                                          direction={orderBy === "marketer_user_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("marketer_user_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"usermarketer_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "usermarketer_id" ? order : false}
                                                                              >
                                                                                    {"شماره درخواست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "usermarketer_id"}
                                                                                          direction={orderBy === "usermarketer_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("usermarketer_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"user_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام کاربر  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_name"}
                                                                                          direction={orderBy === "user_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره همراه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"marketer_timestamp"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"زمان درخواست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "marketer_timestamp"}
                                                                                          direction={orderBy === "marketer_timestamp" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("marketer_timestamp")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["usermarketer_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"marketer_user_id"} align={"center"}>
                                                                                                      {row["marketer_user_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"usermarketer_id"} align={"center"}>
                                                                                                      {row["usermarketer_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"user_name"} align={"center"}>
                                                                                                      {row["user_name"] + " " + row["user_family"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"user_mobile"} align={"center"}>
                                                                                                      {row["user_mobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"marketer_timestamp"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {new JDate(
                                                                                                            new Date(
                                                                                                                  parseInt(
                                                                                                                        Moment(
                                                                                                                              row[
                                                                                                                                    "marketer_timestamp"
                                                                                                                              ],
                                                                                                                              "YYYY-M-D HH:mm:ss"
                                                                                                                        ).format("x")
                                                                                                                  )
                                                                                                            )
                                                                                                      ).format("YYYY/MM/DD ") +
                                                                                                            "ساعت " +
                                                                                                            Moment(
                                                                                                                  row["marketer_timestamp"],
                                                                                                                  "YYYY-M-D HH:mm:ss"
                                                                                                            ).format("HH:mm")}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}

                              {this.state.openImageBox && (
                                    <Lightbox
                                          medium={urlToLargeImageFile}
                                          large={urlToHugeImageFile}
                                          alt={descImageFile}
                                          onClose={this.closeLightbox}
                                          showRotate={true}
                                          hideZoom={false}
                                    />
                              )}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeMarketerReject)
